class ProductObj {

    constructor(variantID, name, imgUrl, type, price, url, quantity, variantTitle) {
        this.variantID = variantID;
        this.name = name;
        this.imgUrl = imgUrl;
        this.type = type.trim().toLowerCase();
        this.price = price
        this.url = url;
        this.quantity = quantity - 0;
        this.variantTitle = variantTitle; // Este dato, en el caso de las tortas, contiene el tamaño seleccionado (torta de 15 o 25 personas). Lo usamos en el method defineCakeSize()
    }

    defineCakeSize() {

        if (this.type != "tortas" || this.variantTitle == null) {
            return null;
        }

        let sizeSplitedWords = this.variantTitle.split(' '); // separamos la string "25 personas" y obtenermos el número.
        const cakeSize = sizeSplitedWords.filter((word) => {
            return !isNaN(word);
        })

        if (cakeSize.length == 0) {
            throw new Error("No se encontró size en producto tipo torta");
        }

        return cakeSize[0] - 0; // parseamos a número
    }

    get priceCLP() {
        return `$${new Intl.NumberFormat("cl-CL", {maximumFractionDigits:0}).format(this.price).replace(",", ".")}`; // convertimos a $CLP
    }

    get size() {
        return this.defineCakeSize();
    }

    get data() {

        return { // props in view (snippets/pre-cart_24.liquid)
            variant_id: this.variantID,
            name: this.name,
            img_url: this.imgUrl,
            price_clp: this.priceCLP,
            size: this.size,
            type: this.type,
            quantity: this.quantity,
            variant_title: this.variantTitle,
            url: this.url
        }
    }
}

class ProductObjRelated {

    constructor(title, featuredImage, variants) {
        this.name = title;
        this.imageUrl = featuredImage;
        this.variants = variants;
    }

    pickVariantLowerPrice() {

        if (this.variants.length > 1) {

            let variantLowerPrice = this.variants[0];

            for (var i = 1; i < this.variants.length; i++) {

                if (this.variants[i].price < variantLowerPrice.price) {
                    variantLowerPrice = this.variants[i];
                }
            }

            return variantLowerPrice;
        }

        return this.variants[0];
    }

    get priceCLP() {
        return `$${ new Intl.NumberFormat("cl-CL", {maximumFractionDigits:0}).format(this.pickVariantLowerPrice().price / 100).replace(",", ".")}`; // convertimos a $CLP
    }

    get variantID() {
        return this.pickVariantLowerPrice().id
    }

    get data() {

        return {
            name: this.name,
            variant_id: this.variantID,
            img_url: this.imageUrl,
            price_clp: this.priceCLP,
        }
    }
}

window.addEventListener('alpine:init', () => {

    Alpine.data('precart', () => ({

        open: false,
        selector: "._pre-cart",
        products: [],
        counter: 0,
        globalCounterSelector: "#_bag-new-precart-7246d1e4",
        busy: false,
        total: 0,
        deliveryInfo: {
            free: false,
            diff: null,
            text: ""
        },

        minAmount: 50000,

        productsRelated: [],

        get defaultInfo() {
            const minAmountCLP = new Intl.NumberFormat("cl-CL", { style: "currency", currency: "CLP" }).format(this.minAmount);
            return `Compras sobre ${minAmountCLP} delivery es costo $0.`;
        },

        get totalClp() {
            return `$${new Intl.NumberFormat("cl-CL", {maximumFractionDigits:0}).format(this.total/100).replace(",", ".")}`; // convertimos a $CLP
        },

        async init() {

            const precart = document.querySelector(this.selector);

            var globalCounter = document.querySelector(this.globalCounterSelector);

            if (!precart || !globalCounter) {
                throw new Error("PRECART, No se encontró el dom | global counter");
            }

            const resFrist = await this.fetchCart(); // first fetch for global counter

            globalCounter.querySelector('._acc').innerHTML = resFrist.item_count; // pass first count

            globalCounter.addEventListener("click", () => { // click on bag icon
                window.dispatchEvent(new CustomEvent("precart", {detail:{show:true}}));
            });

            window.addEventListener("precart", async (e) => {

                if (!e.detail.show) {
                    return
                }

                this.busy = true;
                this.open = true;

                window.glide = new Glide('._related ._glide');
                glide.destroy();

                try {
                    
                    const cartData = await this.fetchCart();

                    this.counter = cartData.item_count;

                    if (this.counter == 0) {

                        document.querySelector("._layer-empty").style.display = "block";

                        return;
                    }

                    await this.handleProductsLoop(cartData);

                    this.calculateDelivery();

                    const recommendationData = await this.fetchRecommendation(cartData.items[0].product_id);

                    await this.handleRecommendationLoop(recommendationData.products);

                    glide.update({
                        type: "carousel",
                        perView: 3,
                        gap: 3,
                        peek: {
                            before: 0,
                            after: 0
                        },

                        breakpoints: {
                            430: {
                                perView: 2,
                                gap: 13,
                                peek: {
                                    before: 0,
                                    after: 80
                                },
                            },
                        }
                    });

                    glide.mount();

                } catch (error) {
                    console.error(error);

                } finally {
                    this.busy = false;
                }
            });

            this.$watch('busy', (value) => {
                const loading = document.querySelector("._layer-loading");

                if (value) {
                    loading.style.display = "block";
                    return;
                }

                setTimeout(() => {
                    loading.style.display = "none";
                }, 3000)
            });

            this.$watch('counter', (value) => {
                const empty = document.querySelector("._layer-empty");

                globalCounter.querySelector('._acc').innerHTML = value;

                if (value != 0) {
                    empty.style.display = "none";
                    return;
                }

                this.products = [];
                this.productsRelated = [];
                empty.style.display = "block";
            });

            this.$watch('total', (value) => {
                this.calculateDelivery()
            });

            this.$watch('open', (value) => {
                if (value) {
                    document.querySelector("#shopify-chat").style.display = "none";
                    document.getElementsByTagName("html")[0].style.overflow = "hidden";
                    document.querySelector(".__layer-precart-bg ").style.display = "block";
                    return
                }
                document.getElementsByTagName("html")[0].style.overflow = "initial";
                document.querySelector("#shopify-chat").style.display = "block";
                document.querySelector(".__layer-precart-bg ").style.display = "none";
            });

        },


        calculateDelivery() {

            let total = this.total / 100;

            if (total >= this.minAmount) {
                this.deliveryInfo.free = true;
                this.deliveryInfo.diff = null;
                this.deliveryInfo.text = "Actualmente tienes delivery gratis."
                return;
            }

            this.deliveryInfo.free = false;
            this.deliveryInfo.diff = this.minAmount - total;
            const diffCLP = `$${new Intl.NumberFormat("cl-CL",{maximumFractionDigits:0}).format(this.deliveryInfo.diff).replace(",", ".")}`;
            this.deliveryInfo.text = `Te faltan ${diffCLP} en productos para delivery gratis.`;
        },

        async updateCart(variantID, qty) {

            this.products.forEach(item => {
                if (item.variant_id == variantID) {
                    item.quantity = qty;
                }
            });

            const updates = {};

            this.products.forEach((item) => {
                updates[item.variant_id] = item.quantity;
            })

            try {
                this.busy = true;

                const res = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates })
                });

                if (!res.ok) {
                    throw new Error('UPDATECART::No se pudo actualizar el cart')
                }

                const data = await res.json();

                this.counter = data.item_count;

                this.handleProductsLoop(data)

            } catch (error) {
                console.error(error)

            } finally {
                this.busy = false;
            }
        },

        async removeCart(variantID) { // remove

            let remove;

            this.products.forEach(item => {
                if (item.variant_id == variantID) {
                    remove = { 'id': variantID.toString(), 'quantity': 0 }
                }
            });

            try {
                this.busy = true;

                const res = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(remove)
                });

                if (!res.ok) {
                    throw new Error('REMOVECART::No se pudo remover item del cart')
                }

                const data = await res.json();

                this.counter = data.item_count;

                if (this.counter == 0) {
                    return;
                }

                this.handleProductsLoop(data);

            } catch (error) {
                console.error(error)

            } finally {
                this.busy = false;
            }
        },

        async fetchCart() {

            try {
                const res = await fetch('/cart.js');

                if (!res.ok) {
                    throw new Error("FIRST FETCH CART:: No se pudo realizar el primer fetch");
                }

                const data = await res.json();

                return data;

            } catch (error) {
                console.error(error);

                throw error;
            }
        },

        handleProductsLoop(data) {

            return new Promise((resolve) => {

                const arr = Array.from(data.items).map((item) => {
                    const product = new ProductObj(
                        item.variant_id,
                        item.product_title,
                        item.featured_image.url,
                        item.product_type,
                        item.presentment_price,
                        item.url,
                        item.quantity,
                        item.variant_title
                    );

                    return product.data;
                });

                this.products = arr;

                this.total = data.total_price;

                resolve("ok");
            });

        },

        async fetchRecommendation(id) {

            const params = new URLSearchParams({
                'product_id': id,
                'limit': 10,
                'intent': 'related'
            });

            const url = `/recommendations/products.json?${params}`;

            try {

                const res = await fetch(url, {
                    method: 'GET'
                });

                if (!res.ok) {
                    throw new Error("FETCH RECOMMENDATION:: No se puede recuperar recomendaciones");
                }

                const data = await res.json();

                return data;

            } catch (error) {

                console.error(error);

                throw error;
            }
        },

        async addCart(variantID, qty) {

            let data = {
                'items': [{
                    'id': variantID,
                    'quantity': 1,
                }]
            };

            let options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }

            try {

                this.busy = true;

                const res = await fetch('/cart/add.js', options);

                if(!res.ok) {
                    throw new Error('ADDCART:: No se pudo agregar producto recomendado');
                }

                const data = await res.json();

                window.glide.destroy();

                window.dispatchEvent(new CustomEvent("precart", {detail: {show:true}}));
    
            } catch (error) {

                console.error(error);

                throw error;

            } finally {
                this.busy = false;
            }
        },

        handleRecommendationLoop(data) {

            return new Promise((resolve, reject) => {

                try {

                    if (!Array.isArray(data) || data == undefined) {
                        this.productsRelated = [];
                        throw new Error("HANDLERECOMMENDATION::Dato no es un array");
                    }

                    if (data.length == 0) {
                        this.productsRelated = [];
                        throw new Error("HANDLERECOMMENDATION::No se encontraron productos recomendados");
                    }

                    const arr = Array.from(data).map((item) => {
                        const productRelated = new ProductObjRelated(
                            item.title,
                            item.featured_image,
                            item.variants);

                        return productRelated.data;
                    });

                    this.productsRelated = arr;

                    const glide = document.querySelector("._related .glide__slides");

                    if (glide) {

                        let slides = "";

                        Array.from(this.productsRelated).forEach((item) => {
                            let maxLength = 27;
                            let itemNameSliced= item.name.length >= maxLength ? item.name.slice(0, maxLength-3)+'...': item.name; // line clamp name (...)
                            slides += `<li class="glide__slide"><div class="_card-related" data-variantid="${item.variant_id}"><img src="${item.img_url}"><h4 class="_name">${itemNameSliced}</h4><span>${item.price_clp}</span><button @click="addCart(${item.variant_id})" type="button" class="_btn-add">Agregar</button</div></li>`;
                        });

                        glide.innerHTML = slides;
                    }

                    let slides = document.querySelectorAll(".glide__slide")

                    setTimeout(() => {
                        resolve(slides.length)
                    }, 900);

                } catch (error) {
                    reject(error)
                }

            });
        }

    }))
});